import React, { ChangeEvent, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import DateComponent from '../../commonComponents/DateComponent';
import { DateType } from '../../../static/types/commonTypes/dateType';
import DescriptionTextComponent from '../../commonComponents/DescriptionText';
import Manager from '../../commonComponents/Manager';
import ManagerListWithQualities from '../../commonComponents/ManagerListWithQualities';
import { initialManagerListStatewithQualities, initialManagerState } from '../../../static/types/objectInitialState';
import ReducedManager from '../../commonComponents/ReducedManager';
import { initialReducedManagerState } from '../../../static/initialState/commonInitialState/initialReducedManagerState';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { ManagerType, ManagerTypeWithQualite } from '../../../static/types/commonTypes/managerType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { ReducedManagerType } from '../../../static/types/commonTypes/reducedManagerType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { DescriptionTextType } from '../../../static/types/commonTypes/descriptionTextType';
import { formatObjectText } from '../../../utils/functions/formatObjectText';
import { Key } from 'lucide-react';

interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const TransformationSARLenSAS: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,

}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        decisionWithQuality, setDecisionWithQuality,
        decisionWithQualityValidity, setDecisionWithQualityValidity,
        decisionWithQualityChecked, setDecisionWithQualityChecked,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

        admissionDescriptionText, setAdmissionDescriptionText,
        admissionDescriptionTextValidity, setAdmissionDescriptionTextValidity,
        admissionDescriptionTextChecked, setAdmissionDescriptionTextChecked,

        clauseDescriptionText, setClauseDescriptionText,
        clauseDescriptionTextValidity, setClauseDescriptionTextValidity,
        clauseDescriptionTextChecked, setClauseDescriptionTextChecked,

        manager, setManager,
        managerChecked, setManagerChecked,
        managerValidity, setManagerValidity,

        generalManagersWithQualite, setGeneralManagersWithQualite,
        generalManagersWithQualiteValidity, setGeneralManagersWithQualiteValidity,
        generalManagersWithQualiteChecked, setGeneralManagersWithQualiteChecked,

        typeTransformationOfSociety, setTypeTransformationOfSociety,

        inputGeneralDirector, setInputGeneralDirector,

        auditorChange, setAuditorChange,

        newStatutoryAuditor, setNewStatutoryAuditor,
        newStatutoryAuditorValidity, setNewStatutoryAuditorValidity,
        newStatutoryAuditorChecked, setNewStatutoryAuditorChecked,

        formerStatutoryAuditor, setFormerStatutoryAuditor,
        formerStatutoryAuditorValidity, setFormerStatutoryAuditorValidity,
        formerStatutoryAuditorChecked, setFormerStatutoryAuditorChecked,

        // new reduced statutory auditor for Departure with replacement of the statutory auditor and alternate(ManagerType)
        newAlternateAuditor, setNewAlternateAuditor,
        newAlternateAuditorValidity, setNewAlternateAuditorValidity,
        newAlternateAuditorChecked, setNewAlternateAuditorChecked,
        typeNewAlternateAuditorData, setTypeNewAlternateAuditorData,

        // former reduced statutory auditor alternate for Departure with replacement of the statutory auditor and alternate (ReduceManager)
        formerAlternateAuditor, setFormerAlternateAuditor,
        formerAlternateAuditorValidity, setFormerAlternateAuditorValidity,
        formerAlternateAuditorChecked, setFormerAlternateAuditorChecked,
        typeFormerAlternateAuditorData, setTypeFormerAlternateAuditorData,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [ submissive, setSubmissive ] = useState<boolean>( false );
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const decisionChange = decisionWithQuality.decisionNature === "AG Extraordinaire"
                ? "AGE"
                : decisionWithQuality.decisionNature === "AG Ordinaire"
                    ? "AGO"
                    : decisionWithQuality.decisionNature === "AG Mixte"
                        ? "AG Mixte"
                        : decisionWithQuality.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQuality.decisionNature) ? `Aux termes de l'${decisionChange} en date du ${decisionWithQuality.decisionDate} ${decisionWithQuality.decisionQuality.toLowerCase()} ${decisionWithQuality.decisionQuality.toLocaleLowerCase().includes("les") ? "ont" : "a"} décidé de transformer la société en ${typeTransformationOfSociety}` : `Le ${decisionWithQuality.decisionDate}, ${decisionWithQuality.decisionNature.toLowerCase()} a décidé de transformer la société en ${typeTransformationOfSociety}`;

            const managerText = (manager: ManagerType) => {
                if (manager.person === "Personne morale") {
                    return manager.entityDetails.rcs ? ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : ``
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
            }

            const processedManagersData = generalManagersWithQualite.reduce((accumulator: { [key: string]: Array<ManagerTypeWithQualite> }, currentManager: ManagerTypeWithQualite) => {
                if (accumulator[currentManager.qualite]) {
                    accumulator[currentManager.qualite] = [...accumulator[currentManager.qualite], currentManager]
                }
                else {
                    accumulator[currentManager.qualite] = [currentManager]
                }
                return accumulator
            }, {})

            const directorText = (manager: ManagerTypeWithQualite): string => {
                if (manager.person === "Personne morale") {
                    return manager.entityDetails.rcs ? ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : ``
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
                else return ""
            }

            const qualityPlural = (quality: string) => {
                return quality === 'Directeur Général' ? 'Directeurs Généraux' : 'Directeurs Généraux Délégués'
            }

            const reducedManagerText = (manager: ReducedManagerType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}`
                }
                else return ''
            }

            const auditorText = (): string => {
                let res = ``

                if( auditorChange === 1 ){
                    res = typeNewAlternateAuditorData === 1
                        ? `Sont nommés Commissaires aux comptes :
- Titulaire : ${managerText(newStatutoryAuditor)}
- Suppléant : ${managerText(newAlternateAuditor)}`
                        : `Est nommé Commissaires aux comptes titulaire, ${managerText(newStatutoryAuditor)}.`
                }
                else if( auditorChange === 2 ){
                    res = typeFormerAlternateAuditorData === 1
                        ? `Les Commissaires aux comptes titulaire et suppléant, respectivement ${reducedManagerText(formerStatutoryAuditor)} et ${reducedManagerText(formerAlternateAuditor)}, ont été maintenus dans leurs fonctions.`
                        : `Le Commissaire aux comptes titulaire ${reducedManagerText(formerStatutoryAuditor)}, a été maintenu dans ses fonctions.`
                }
                else if( auditorChange === 3 ){
                    res = typeFormerAlternateAuditorData === 1
                        ? `Suite à la transformation, il est mis fin aux fonctions des Commissaires aux comptes titulaire et suppléant, respectivement ${reducedManagerText(formerStatutoryAuditor)} et ${reducedManagerText(formerAlternateAuditor)}.`
                        : `Suite à la transformation, il est mis fin aux fonctions du Commissaire aux comptes titulaire ${reducedManagerText(formerStatutoryAuditor)}.`
                }
                else if( auditorChange === 4 ){
                    if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 0 )
                    res = `Suite à la transformation, est nommé Commissaire aux comptes Titulaire, ${ managerText( newStatutoryAuditor )}, en remplacement de ${ reducedManagerText( formerStatutoryAuditor )}.`
                
                    else if( typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1 ) {
                        res = `Suite à la transformation, il a été décide de :
- Nommer Commissaire aux comptes Titulaire : ${managerText(newStatutoryAuditor)}, en remplacement de  ${reducedManagerText(formerStatutoryAuditor)}
- Prendre acte de la cessation des fonctions du Commissaire Aux Comptes Suppléant ${reducedManagerText(formerAlternateAuditor)}`
                    }

                    else if (typeNewAlternateAuditorData === 1) {
                        res = `Suite à la transformation, sont nommés Commissaires aux comptes :
- Titulaire : ${managerText(newStatutoryAuditor)}, en remplacement de  ${reducedManagerText(formerStatutoryAuditor)}
- Suppléant : ${managerText(newAlternateAuditor)} ${typeFormerAlternateAuditorData === 1 ? `, en remplacement de ${reducedManagerText(formerAlternateAuditor)}` : ``}`
                    }
                }
                return res
            }

            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €.
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.
${decisionText}, sans création d'un être moral nouveau${date.date ? `, à compter du ${date.date}` : ``} et a nommé Président ${managerText(manager)}.${inputGeneralDirector === 1 ? `${Object.keys(processedManagersData).map((currentQuality: string) => `
Il a été nommé ${processedManagersData[currentQuality].length > 1 ? qualityPlural(currentQuality) : currentQuality}: ${processedManagersData[currentQuality].map((manager: ManagerTypeWithQualite) => directorText(manager)).join(" et ")}`).join(", ")}` : ``}
${auditorText()}.
Accès aux assemblées et vote : ${admissionDescriptionText.descriptionText}.
Transmission des actions : ${clauseDescriptionText.descriptionText}.
Modification du RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true)
        }
    };

    const auditorValidity = (): boolean => {

        let res = false

        if ( auditorChange === 0 ) res = true
        else if (auditorChange === 1) {
            if( typeNewAlternateAuditorData === 1 ){
                if(  newStatutoryAuditorValidity && newAlternateAuditorValidity ) res = true
            }
            else if (newStatutoryAuditorValidity) res = true
        }
        else if ( auditorChange ===  2 || auditorChange ===  3 ) {
            if( typeFormerAlternateAuditorData === 1 ){
                if(  formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) res = true
            }
            else if (formerStatutoryAuditorValidity) res = true
        }
        else if (auditorChange === 4) {
            if( newStatutoryAuditorValidity && formerStatutoryAuditorValidity ){
                if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                    if( newAlternateAuditorValidity && formerAlternateAuditorValidity ) res = true
                }
                else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0) {
                    if (newAlternateAuditorValidity) res = true
                }
                else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1) {
                    if (formerAlternateAuditorValidity) res = true
                }
                else res = true
            }
        }
        return res
    }

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        } else if (!legalEntityValidity) {
            setActiveTab('theSociety')
        } else if (!decisionWithQualityValidity) {
            setActiveTab('decision')
        } else if (!admissionDescriptionTextValidity) {
            setActiveTab('admissionToMeetingsAndVoting')
        } else if (!clauseDescriptionTextValidity) {
            setActiveTab('clauseAgrement')
        } else if (!managerValidity) {
            setActiveTab ('thePresident')
        } else if ( inputGeneralDirector === 1 && !generalManagersWithQualiteValidity ) {
            setActiveTab ('generalManagerAndOtherOfficers')
        } else if (auditorChange === 0) {
            setActiveTab('auditor')
        } else if (auditorChange === 1) {
            if( typeNewAlternateAuditorData === 1 ){
                if( !( newStatutoryAuditorValidity && newAlternateAuditorValidity )) setActiveTab('auditor')
            }
            else if( !newStatutoryAuditorValidity ) setActiveTab('auditor')
        } else if ( auditorChange === 2 || auditorChange === 3 ) {
            if( typeFormerAlternateAuditorData === 1 ){
                if( !( formerStatutoryAuditorValidity && formerAlternateAuditorValidity )) setActiveTab('auditor')
            }
            else if( !formerStatutoryAuditorValidity ) setActiveTab('auditor')
        } else if ( auditorChange === 4 ) {
            if( !(newStatutoryAuditorValidity && formerStatutoryAuditorValidity )) setActiveTab('auditor')
            if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                if( !(newAlternateAuditorValidity && formerAlternateAuditorValidity )) setActiveTab('auditor')
            }
            else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0) {
                if (!newAlternateAuditorValidity) setActiveTab('auditor')
            }
            else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1) {
                if (!formerAlternateAuditorValidity) setActiveTab('auditor')
            }
        } 

        let tempAuditorValidation = auditorValidity()
        let tempGeneralManagersValidity = inputGeneralDirector === 1 ? generalManagersWithQualiteValidity : true

        return companyNameValidity && legalEntityValidity && decisionWithQualityValidity && admissionDescriptionTextValidity && clauseDescriptionTextValidity && managerValidity && tempGeneralManagersValidity && tempAuditorValidation;
    }

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "decision") {
            setDecisionWithQualityChecked(true)
            if (decisionWithQualityValidity) {
                switchTab(getNextTab("decision"));
            }
        } else if (activeTab === "transformationSARL-SAS") {
            switchTab(getNextTab("transformationSARL-SAS"));
        } else if (activeTab === "date") {
            switchTab(getNextTab("date"));
        } else if (activeTab === "admissionToMeetingsAndVoting") {
            setAdmissionDescriptionTextChecked(true)
            if (admissionDescriptionTextValidity) {
                switchTab(getNextTab("admissionToMeetingsAndVoting"));
            }
        } else if (activeTab === "clauseAgrement") {
            setClauseDescriptionTextChecked(true)
            if (clauseDescriptionTextValidity) {
                switchTab(getNextTab("clauseAgrement"))
            }
        } else if (activeTab === "thePresident") {
            setManagerChecked(true)
            if (managerValidity) {
                switchTab(getNextTab("thePresident"))
            }
        } else if (activeTab === "generalManagerAndOtherOfficers") {
            if (inputGeneralDirector === 1) {
                setGeneralManagersWithQualiteChecked(true)
                if (generalManagersWithQualiteValidity) {
                    switchTab(getNextTab("generalManagerAndOtherOfficers"))
                }
            } else switchTab(getNextTab("generalManagerAndOtherOfficers"))
        } else if (activeTab === "auditor") {
            if (auditorChange === 1) {
                setNewStatutoryAuditorChecked( true )
                if( typeNewAlternateAuditorData === 1 ){
                    setNewAlternateAuditorChecked( true )
                    if( newStatutoryAuditorValidity && newAlternateAuditorValidity ) setSubmissive( true )
                }
                else if( newStatutoryAuditorValidity ) setSubmissive( true )
            } else if (auditorChange === 2) {
                setFormerStatutoryAuditorChecked( true )
                if( typeFormerAlternateAuditorData === 1 ){
                    setFormerAlternateAuditorChecked( true )
                    if( formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) setSubmissive( true )
                }
                else if( formerStatutoryAuditorValidity ) setSubmissive( true )
            } else if (auditorChange === 3) {
                setFormerStatutoryAuditorChecked( true )
                if( typeFormerAlternateAuditorData === 1 ){
                    setFormerAlternateAuditorChecked( true )
                    if( formerStatutoryAuditorValidity && formerAlternateAuditorValidity ) setSubmissive( true )
                }
                else if( formerStatutoryAuditorValidity ) setSubmissive( true )
            } else if (auditorChange === 4) {
                setNewStatutoryAuditorChecked( true )
                setFormerStatutoryAuditorChecked( true )
                if( newStatutoryAuditorValidity && formerStatutoryAuditorValidity ){
                    if( typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 1 ){
                        setFormerAlternateAuditorChecked( true )
                        setNewAlternateAuditorChecked( true )
                        if( newAlternateAuditorValidity && formerAlternateAuditorValidity ) setSubmissive ( true )
                    }
                    else if (typeNewAlternateAuditorData === 1 && typeFormerAlternateAuditorData === 0) {
                        setNewAlternateAuditorChecked(true)
                        if (newAlternateAuditorValidity) setSubmissive(true)
                    }
                    else if (typeNewAlternateAuditorData === 0 && typeFormerAlternateAuditorData === 1) {
                        setFormerAlternateAuditorChecked(true)
                        if (formerAlternateAuditorValidity) setSubmissive(true)
                    }
                    else setSubmissive(true)
                }
            } else setSubmissive(true)
        }

    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "theSociety";
        else if (currentTab === "theSociety") return "decision";
        else if (currentTab === "decision") return "transformationSARL-SAS";
        else if (currentTab === "transformationSARL-SAS") return "date";
        else if (currentTab === "date") return "admissionToMeetingsAndVoting";
        else if (currentTab === "admissionToMeetingsAndVoting") return "clauseAgrement";
        else if (currentTab === "clauseAgrement") return "thePresident";
        else if (currentTab === "thePresident") return "generalManagerAndOtherOfficers";
        else if (currentTab === "generalManagerAndOtherOfficers") return "auditor";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "auditor") return "generalManagerAndOtherOfficers";
        else if (currentTab === "generalManagerAndOtherOfficers") return "thePresident";
        else if (currentTab === "thePresident") return "clauseAgrement";
        else if (currentTab === "clauseAgrement") return "admissionToMeetingsAndVoting";
        else if (currentTab === "admissionToMeetingsAndVoting") return "date";
        else if (currentTab === "date") return "transformationSARL-SAS";
        else if (currentTab === "transformationSARL-SAS") return "decision";
        else if (currentTab === "decision") return "theSociety";
        else if (currentTab === "theSociety") return "companyName";
        else return currentTab;
    };

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName ({...companyName, ...data});

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQuality({ ...decisionWithQuality, ...data });

    const updateDate = (data: Partial<DateType>) => setDate({ ...date, ...data });

    const updateAdmissionDescriptionText = (data: Partial<DescriptionTextType>) => setAdmissionDescriptionText({ ...admissionDescriptionText, ...data });

    const updateClauseDescriptionText = (data: Partial<DescriptionTextType>) => setClauseDescriptionText({ ...clauseDescriptionText, ...data });

     const handleToggleAuditorsChange = ( event: ChangeEvent<HTMLSelectElement> ) => {
    
            setAuditorChange(Number(event.target.value))
            setSubmissive( false )
    
            setNewStatutoryAuditor (initialManagerState)
            setNewStatutoryAuditorValidity (false)
            setNewStatutoryAuditorChecked (false)
        
            setNewAlternateAuditor (initialManagerState)
            setNewAlternateAuditorValidity (false)
            setNewAlternateAuditorChecked (false)
            setTypeNewAlternateAuditorData (0)
        
            setFormerStatutoryAuditor (initialReducedManagerState)
            setFormerStatutoryAuditorValidity (false)
            setFormerStatutoryAuditorChecked (false)
        
            setFormerAlternateAuditor (initialReducedManagerState)
            setFormerAlternateAuditorValidity (false)
            setFormerAlternateAuditorChecked (false)
            setTypeFormerAlternateAuditorData (0)
        }
        
    const changeOption: string[] = ['SAS','SAS à capital variable','SAS à associé unique','SASU']

    const tabs =[
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'theSociety', label: 'La société'},
        {key: 'decision', label: 'La décision'},
        {key: 'transformationSARL-SAS', label: 'Transformation SARL / EURL en SAS'},
        {key: 'date', label: 'A compter du'},
        {key: 'admissionToMeetingsAndVoting', label: 'Admission aux assemblées et droits de vote'},
        {key: 'clauseAgrement', label: "Clauses d'agrément"},
        {key: 'thePresident', label: 'Le président'},
        {key: 'generalManagerAndOtherOfficers', label: 'Le directeur général et autres dirigeants'},

    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                        checked={legalEntityChecked}
                        legalEntity={legalEntity}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                        societyType={societyTypeOptions}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'decision' &&
                        <DecisionWithQuality
                            decisionWithQuality={decisionWithQuality}
                            draftFieldName = 'decisionWithQuality'
                            checked={decisionWithQualityChecked}
                            dateLabel='Date'
                            changeDecision={updateDecision}
                            onValidationChange={(isValid: boolean) => setDecisionWithQualityValidity(isValid)}
                            decisionQualityOptions={[
                                "L'associé unique",
                                "Les associés",
                                "Les actionnaires"
                            ]}
                            decisionNatureOptions={[
                                "AG Extraordinaire",
                                "AG Ordinaire",
                                "AG Mixte",
                                "Le gérant",
                                "Le président",
                                "Le conseil d'administration",
                                "Décision unanime des associés"
                            ]}
                        />
                }

                {
                    activeTab === 'transformationSARL-SAS' &&
                    <div >
                        <div className='col-sm-10 d-flex align-items-center mt-1'>
                            <label htmlFor="modification" className="col-sm-auto col-form-label me-2">
                                Transformation en <strong className="text-danger">*</strong>
                            </label>
                            <select
                                className='form-select w-75'
                                id="modificationCAC"
                                onChange={(e) => {
                                    setTypeTransformationOfSociety(e.target.value)
                                }}
                                value={typeTransformationOfSociety}
                            >
                                {
                                    changeOption.map((value, key) => <option value={value} key={key}>{value}</option>)
                                }
                            </select>
                        </div>
                    </div>
                }

                {
                    activeTab === 'date' &&
                    <DateComponent
                        id='dateTransformationSARL/SAS'
                        dateLabel="Date d'effet"
                        date={date}
                        checked={dateChecked}
                        changeDate={updateDate}
                        required={false}
                        onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                    />
                }

                {
                    activeTab === 'admissionToMeetingsAndVoting' &&
                    <div>
                        <span>
                            Résumez ici le chapitre de vos statuts concernant l'admission aux assemblées et aux droits de votes.
                        </span>
                        <DescriptionTextComponent
                            checked={admissionDescriptionTextChecked}
                            descriptionText={admissionDescriptionText}
                            labelDescription='Admission'
                            updateDescriptionText={updateAdmissionDescriptionText}
                            onValidationDescriptionText={(isValid: boolean) => setAdmissionDescriptionTextValidity(isValid)}
                            fieldDescription="Exemple de formulation : Tout actionnaire peut participer aux assemblées, quel que soit le nombre de ses actions, chaque action donnant droit à une voix."
                            defaultValue="Tout actionnaire peut participer aux Assemblées. Chaque action donne droit à une voix."
                        />
                    </div>
                }

                {
                    activeTab === 'clauseAgrement' &&
                    <div>
                        <span>
                            Résumez ici le chapitre de vos statuts concernant les cessions d'actions.
                        </span>
                        <DescriptionTextComponent
                            checked={clauseDescriptionTextChecked}
                            descriptionText={clauseDescriptionText}
                            labelDescription='Clause'
                            updateDescriptionText={updateClauseDescriptionText}
                            onValidationDescriptionText={(isValid: boolean) => setClauseDescriptionTextValidity(isValid)}
                            fieldDescription="Exemple de formulation : Cession libre entre associés, ainsi qu'à leurs conjoints, ascendants ou descendants, et soumise à agrément dans les autres cas."
                            defaultValue= "La cession d'actions à un tiers à quelque titre que ce soit est soumise à l'agrément préalable des associés, statuant à la majorité des associés disposant du droit de vote."
                        />
                    </div>
                }

                {
                    activeTab === 'thePresident' &&
                    <Manager
                        manager={manager}
                        setManager={setManager}
                        checked={managerChecked}
                        setChecked={setManagerChecked}
                        societyType={societyTypeOptions}
                        updateManagerValidity={(isValid: boolean) => setManagerValidity(isValid)}
                        draftFieldName = 'manager'
                    />
                }

                {
                    activeTab === 'generalManagerAndOtherOfficers' &&
                    <div className='mt-3'>
                        <span>
                            Si vous nommez un Directeur Général différent du Président (habilité à engager la société vis à vis des tiers) et/ou un ou des Directeur(s) Général(aux) Délégué(s), saisir leurs coordonnées.
                        </span>
                        <div className='col-sm-10 d-flex align-items-center mt-1'>
                            <label htmlFor="modification" className="col-sm-auto col-form-label me-3">
                                Saisir un DG / DGD
                            </label>
                            <select
                                className='form-select w-75'
                                id='person'
                                onChange={(e) => {
                                    setGeneralManagersWithQualite(initialManagerListStatewithQualities)
                                    setInputGeneralDirector(Number(e.target.value))
                                }}
                                value={inputGeneralDirector}
                            >
                                <option value={1}>Oui</option>
                                <option value={0}>Non</option>
                            </select>
                        </div>
                        {
                            inputGeneralDirector === 1 &&
                            <ManagerListWithQualities
                                managers={generalManagersWithQualite}
                                setManagers={setGeneralManagersWithQualite}
                                checked={generalManagersWithQualiteChecked}
                                setManagersValidity={setGeneralManagersWithQualiteValidity}
                                addButtonText='Ajouter un dirigeant'
                                removeButtonText='Supprimer le dernier dirigeant'
                                qualitiesOptions={[
                                    "Directeur Général",
                                    "Directeur Général Délégué"
                                ]}
                                societyTypeOptions={societyTypeOptions}
                            />
                        }
                    </div>
                }

                {
                    activeTab === 'auditor' && 
                    <div>
                        <span>
                            La société avait-elle des commissaires aux comptes avant la transformation ?
                        </span>
                        <div className='col-sm-10 d-flex align-items-center mt-1'>
                            <label htmlFor="modification" className="col-sm-2 col-form-label mb-0">
                                Existence de CAC
                            </label>
                            <select
                                className='form-select w-75'
                                id='person'
                                onChange={handleToggleAuditorsChange}
                                value= {auditorChange}
                            >
                                <option value={0}>Non et pas de nomination</option>
                                <option value={1}>Non et il est nécessaire d'en nommer</option>
                                <option value={2}>Oui et ils sont maintenus</option>
                                <option value={3}>Oui et ils ne sont pas maintenus</option>
                                <option value={4}>Oui et ils sont remplacés</option>
                            </select>
                        </div>
                        {
                            auditorChange === 1 &&
                            <>
                                <div>
                                    <div className='mt-3'>
                                        <Manager
                                            manager={newAlternateAuditor}
                                            checked={newAlternateAuditorChecked}
                                            setChecked={setNewAlternateAuditorChecked}
                                            setManager={setNewAlternateAuditor}
                                            societyType={societyTypeOptions}
                                            updateManagerValidity={(isValid: boolean) => setNewAlternateAuditorValidity(isValid)}
                                            draftFieldName = 'newAlternateAuditor'
                                        />
                                    </div>
                                </div>
                                <div className="mt-3 row">
                                    <h6 className='text-bold'>
                                        Ancien commissaire aux comptes suppléant
                                    </h6>
                                    <label htmlFor="personne" className="col-sm-2 col-form-label">
                                        Saisir données
                                    </label>
                                    <div className="col-sm-10">
                                        <select
                                            className="form-select w-25"
                                            id="person"
                                            onChange={(event) => {
                                                setFormerAlternateAuditor(initialReducedManagerState)
                                                setTypeFormerAlternateAuditorData(Number(event.target.value))
                                                setSubmissive(false)
                                            }}
                                            value={typeFormerAlternateAuditorData}
                                        >
                                            <option value={1}> Oui </option>
                                            <option value={0}> Non </option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        }
                        {
                            auditorChange === 2 &&
                                <div>
                                    <div className='mt-3'>
                                        <h6 className='text-bold'>
                                            Commissaire aux comptes titulaire
                                        </h6>
                                            <ReducedManager
                                                checked = { formerStatutoryAuditorChecked }
                                                manager = { formerStatutoryAuditor }
                                                draftFieldName = 'formerStatutoryAuditor'
                                                setChecked = { setFormerStatutoryAuditorChecked }
                                                setManager = { setFormerStatutoryAuditor }
                                                updateManagerValidity = {( isValid ) => setFormerStatutoryAuditorValidity ( isValid )}
                                            />
                                    </div>
                                    <div className='row align-items-center mt-3'>
                                        <h6 className='text-bold'>
                                            Commissaire aux comptes suppléant
                                        </h6>
                                        <div className="col-sm-10">
                                            <select
                                                className="form-select w-25"
                                                id="person"
                                                onChange = {( event ) => {
                                                    setFormerAlternateAuditor (initialReducedManagerState)
                                                    setTypeFormerAlternateAuditorData(Number(event.target.value))
                                                    setSubmissive( false )
                                                }}
                                                value = { typeFormerAlternateAuditorData }
                                            >
                                                    <option value={1}> Oui </option>
                                                    <option value={0}> Non </option>
                                            </select>
                                        </div>
                                        {
                                            typeFormerAlternateAuditorData === 1 &&
                                            <div>
                                                <div className='mt-3'>
                                                    <ReducedManager
                                                        manager = { formerAlternateAuditor }
                                                        draftFieldName = 'formerAlternateAuditor'
                                                        setManager = { setFormerAlternateAuditor }
                                                        setChecked = { setFormerAlternateAuditorChecked }
                                                        checked = { formerAlternateAuditorChecked }
                                                        updateManagerValidity = {( isValid ) => setFormerAlternateAuditorValidity ( isValid )}
                                                    />
                                                </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                        }
                        {
                            auditorChange === 3 &&
                                <div>
                                    <div className='mt-3'>
                                        <h6 className='text-bold'>
                                            Commissaire aux comptes titulaire
                                        </h6>
                                            <ReducedManager
                                                checked = { formerStatutoryAuditorChecked }
                                                manager = { formerStatutoryAuditor }
                                                draftFieldName = 'formerStatutoryAuditor'
                                                setChecked = { setFormerStatutoryAuditorChecked }
                                                setManager = { setFormerStatutoryAuditor }
                                                updateManagerValidity = {( isValid ) => setFormerStatutoryAuditorValidity ( isValid )}
                                            />
                                    </div>
                                    <div className='row align-items-center mt-3'>
                                        <h6 className='text-bold'>
                                            Commissaire aux comptes suppléant
                                        </h6>
                                        <div className="col-sm-10">
                                            <select
                                                className="form-select w-25"
                                                id="person"
                                                onChange = {( event ) => {
                                                    setFormerAlternateAuditor (initialReducedManagerState)
                                                    setTypeFormerAlternateAuditorData(Number(event.target.value))
                                                    setSubmissive( false )
                                                }}
                                                value = { typeFormerAlternateAuditorData }
                                            >
                                                    <option value={1}> Oui </option>
                                                    <option value={0}> Non </option>
                                            </select>
                                        </div>
                                        {
                                            typeFormerAlternateAuditorData === 1 &&
                                            <div>
                                                <div className='mt-3'>
                                                    <ReducedManager
                                                        manager = { formerAlternateAuditor }
                                                        draftFieldName = 'formerAlternateAuditor'
                                                        setManager = { setFormerAlternateAuditor }
                                                        setChecked = { setFormerAlternateAuditorChecked }
                                                        checked = { formerAlternateAuditorChecked }
                                                        updateManagerValidity = {( isValid ) => setFormerAlternateAuditorValidity ( isValid )}
                                                    />
                                                </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                        }
                        {
                            auditorChange === 4 &&
                            <div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Nouveau commissaire aux comptes titulaire
                                    </h6>
                                    <Manager
                                        manager = { newStatutoryAuditor }
                                        setManager = { setNewStatutoryAuditor }
                                        checked = { newStatutoryAuditorChecked }
                                        setChecked = { setNewStatutoryAuditorChecked }
                                        societyType = { societyTypeOptions }
                                        updateManagerValidity = {( isValid: boolean ) => setNewStatutoryAuditorValidity ( isValid )}
                                        draftFieldName = 'newStatutoryAuditor'
                                    />
                                </div>
                                <div className='mt-3'>
                                    <h6 className='text-bold'>
                                        Ancien commissaire aux comptes titulaire
                                    </h6>
                                    <ReducedManager
                                        manager={formerAlternateAuditor}
                                        draftFieldName = 'formerAlternateAuditor'
                                        setManager={setFormerAlternateAuditor}
                                        setChecked={setFormerAlternateAuditorChecked}
                                        checked={formerAlternateAuditorChecked}
                                        updateManagerValidity={(isValid) => setFormerAlternateAuditorValidity(isValid)}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                }

                {
                    submissive &&
                    activeTab === 'auditor' &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'auditor' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'auditor' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'auditor' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default TransformationSARLenSAS;